export type AuthState = 'INITIALIZING' | 'UNAUTHENTICATED' | 'AUTHENTICATED';

export type AuthAction = AuthState;

export const authReducer = (state: AuthState, action: AuthAction) => action;
